import {
  Dropdown,
  DropdownOption,
} from "components/designV2/dropdown/dropdown";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  STAMP_CLOCK_LOGIN_MODE_PERSONAL_IDENTITY,
  STAMP_CLOCK_LOGIN_MODE_PHONE,
} from "../companySettingsMobileView/companySystemSettings/companySystemSettings.logic";
import {
  PassSettingControl,
  PassSettingControls,
} from "../companySettingsMobileView/companySystemSettings/passSettingsV2.styled";
import { SystemSettingRow } from "../companySettingsMobileView/companySystemSettings/systemSettingRow.component";

export const StampClockLoginModeSetting: React.FC<{
  value: string;
  onChange: (v: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options: DropdownOption[] = [
    {
      label: t("System.StampClockLoginModePhoneNumber"),
      value: STAMP_CLOCK_LOGIN_MODE_PHONE,
    },
    {
      label: t("System.StampClockLoginModePersonalIdentityNumber"),
      value: STAMP_CLOCK_LOGIN_MODE_PERSONAL_IDENTITY,
    },
  ];

  return (
    <SystemSettingRow
      title={t("System.StampClockLoginMode")}
      description={t("System.StampClockLoginModeInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <Dropdown
            ariaLabel={t("System.StampClockLoginMode")}
            options={options}
            value={value}
            onChange={onChange}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
